import axios from 'axios';
export const apiBaseUrl = window.baseURL
// export const apiBaseUrl = 'https://api.maanrishfaxyz.xyz/api'
const instance = axios.create({
  baseURL: apiBaseUrl,
});
instance.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default instance;